var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserServiceMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 192V0h192v192z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M95.897 89.397c-18.199 0-32.948-14.75-32.948-32.949 0-18.198 14.75-32.948 32.948-32.948 18.199 0 32.949 14.75 32.949 32.948 0 18.2-14.75 32.949-32.949 32.949",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#b5c7cd",
      fillOpacity: 1,
      strokeWidth: 1.64743,
      strokeMiterlimit: 10
    },
    d: "M95.896 102.576c-47.646 0-65.69 40.235-65.69 40.235L30 168.473h70.273V102.69a82.579 82.579 0 0 0-4.377-.115z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f25022",
    d: "M104 104h37.895v37.895H104z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a4ef",
    d: "M104 146.105h37.895V184H104z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7fba00",
    d: "M146.105 104H184v37.895h-37.895z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb900",
    d: "M146.105 146.105H184V184h-37.895z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserServiceMicrosoft);
export default __webpack_public_path__ + "static/media/userServiceMicrosoft.ada77d2b1d10ad85b5299bc710ae96dd.svg";
export { ForwardRef as ReactComponent };